// src/pages/HomePage.jsx
import HeroSection from "../components/HeroSection";

function HomePage() {
  return (
    <main>
      <HeroSection />
    </main>
  );
}

export default HomePage;
